import React, {useEffect} from 'react';
import {HashRouter, Outlet, Route, Routes, useLocation} from "react-router-dom";
import Layout from "./components/Layout/layout";
import NotFound from "./components/NotFound";
import Index from "./containers/Index";
import SolutionsA from "./containers/solutions/A";
import SolutionsB from "./containers/solutions/B";
import SolutionsC from "./containers/solutions/C";
import SolutionsD from "./containers/solutions/D";
import Productions from "./containers/Productions";
import Data from "./containers/Data";
import Research from "./containers/Research";
import MCP from "./containers/MCP";
import RegModal from "./components/RegModal/Modal"
import {ModalProvider} from "./components/RegModal/ModalContext"
import './styles/global.scss'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PageApply from "./components/RegModal/PageApply";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]); // Only re-run the effect if the pathname changes

  return null;
}

function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <ModalProvider>
        <Routes>
          <Route path="mcp" element={<MCP />} />
          <Route element={<LayoutShell />}>
            <Route path="/" element={<Index />}/>
            <Route path="solutions">
              <Route path="a" element={<SolutionsA />} />
              <Route path="b" element={<SolutionsB />} />
              <Route path="c" element={<SolutionsC />} />
              <Route path="d" element={<SolutionsD />} />
            </Route>
            <Route path="productions" element={<Productions />} />
            <Route path="data" element={<Data />} />
            <Route path="research" element={<Research />} />
            <Route path="apply" element={<PageApply />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
        <RegModal />
      </ModalProvider>
    </HashRouter>

  );
}

function LayoutShell() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

export default App;
